module.exports = __webpack_public_path__ + "img/Solutions-CashAssist.b93e3df0.jpg";